import React from 'react'
import HistoryCard from './HistoryCard'
import UserNav from './UserNav'
import {Heading,Button} from "@chakra-ui/react"
const HistoryPage = () => {
  return (
    <div>
      <UserNav/>
      <Heading>History</Heading>
      <br/>
      <Button>Ongoing</Button>&nbsp;&nbsp;<Button>completed</Button>
      <br/><br/>
      <hr/>
      <br/>
      <div>
        {/* products */}
        <HistoryCard />
      </div>
    </div>
  )
}

export default HistoryPage